import { Box } from '@mui/material';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';
import { buildTabPanelA11yProps } from '../../utils/index';

export const TabPanel = (props: { children?: React.ReactNode; index: number; value: number }) => {
  const { children, value, index, ...other } = props;
  const { isMobile } = useBreakpoint();

  return (
    <div role="tabpanel" hidden={value !== index} {...buildTabPanelA11yProps(index)} {...other}>
      {value === index && <Box sx={{ p: isMobile ? 1 : 3 }}>{children}</Box>}
    </div>
  );
};
